import { render, staticRenderFns } from "./Orderpurchaseedit.vue?vue&type=template&id=517d4ac4&scoped=true&"
import script from "./Orderpurchaseedit.vue?vue&type=script&lang=js&"
export * from "./Orderpurchaseedit.vue?vue&type=script&lang=js&"
import style0 from "./Orderpurchaseedit.vue?vue&type=style&index=0&id=517d4ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d4ac4",
  null
  
)

export default component.exports